export const baseUrl: string | null =
  document.getElementsByTagName('base')[0].getAttribute('href') === '/'
    ? ''
    : document.getElementsByTagName('base')[0].getAttribute('href');

export const baseUrlPublic: string = 'https://webapps.nku.edu/degreemap';

// export const baseFolder: string = '/degreemapadmin';
export const baseFolder: string = '/degreemap';
// export const baseFolder: string = '/';
export const params = new URLSearchParams(window.location.search);
